module.exports = __webpack_public_path__ + "img/Frame-32.2173ca3d.svg";